import { defineStore } from "pinia";
import {CURRENT_LANG, LANG_LIST} from "../lang";

export const useAppStore = defineStore("app", {
    state: () => ({
        lang: CURRENT_LANG,
        langList: LANG_LIST,
    }),
});
